const mentalStateTypeInfo = {
  stress_level: {
    name: 'Stress Level',
    dataBasedOnStates: {
      very_poor: {
        name: 'Extremely High',
        image: 'MEDIA-03031ecdf4a64de38e8c817186cc6cf9',
      },
      poor: {
        name: 'High',
        image: 'MEDIA-0ebcebaf4fec483b8332c8085f275de0',
      },
      moderate: {
        name: 'Moderate',
        image: 'MEDIA-50631301ba864ef5a07a662ab75d05a9',
      },
      good: {
        name: 'Low',
        image: 'MEDIA-871962b59cc04e90b937e17ada1c86f8',
      },
      very_good: {
        name: 'Extremely Low',
        image: 'MEDIA-03031ecdf4a64de38e8c817186cc6cf9',
      },
    },
  },
  social_interaction: {
    name: 'Social Interaction',
    dataBasedOnStates: {
      very_poor: {
        name: 'Very poor',
        image: 'MEDIA-ef208371d69c497f85b9e8ea3e59fc0a',
      },
      poor: {
        name: 'Poor',
        image: 'MEDIA-a553693badbb44ad94c4b036e0e2e620',
      },
      moderate: {
        name: 'Average',
        image: 'MEDIA-7b5a2f0bbea342818de91b68118b33f2',
      },
      good: {
        name: 'Good',
        image: 'MEDIA-60020397b3094e0c92722cd6e5a8be27',
      },
      very_good: {
        name: 'Excellent',
        image: 'MEDIA-559c9d3d518b4a9c9139ee98b786678d',
      },
    },
  },
  job_satisfaction: {
    name: 'Job Satisfaction',
    dataBasedOnStates: {
      very_poor: {
        name: 'Very Dissatisfied',
        image: 'MEDIA-ce2376eb61144d4896714deb22f7a345',
      },
      poor: {
        name: 'Dissatisfied',
        image: 'MEDIA-bd6e432cd9d5467e8e99c55b94400383',
      },
      moderate: {
        name: 'Neutral',
        image: 'MEDIA-fdaba413f2c249658bde5f45097f235e',
      },
      good: {
        name: 'Satisfied',
        image: 'MEDIA-30c91ff873d4445eaf42650bb5905905',
      },
      very_good: {
        name: 'Very Satisfied',
        image: 'MEDIA-fc0f36b6a8954637bc6e787597a52436',
      },
    },
  },
  workload_management: {
    name: 'Workload Management',
    dataBasedOnStates: {
      very_poor: {
        name: 'Overwhelming',
        image: 'MEDIA-67c0763e864548939b6f9699bb98bbc4',
      },
      poor: {
        name: 'Challenging',
        image: 'MEDIA-5da8ad4510674485b0fdc56d608aa34c',
      },
      moderate: {
        name: 'Balanced',
        image: 'MEDIA-377814a9acdd4309bbf339a274bc957f',
      },
      good: {
        name: 'Manageable',
        image: 'MEDIA-ea6f42f33a214db09aa40bfab53ddfd8',
      },
      very_good: {
        name: 'Highly Manageable',
        image: 'MEDIA-7901d486a5c7402ea6d8eac4d910c8be',
      },
    },
  },
  mindfulness_index: {
    name: 'Workload Management',
    dataBasedOnStates: {
      very_poor: {
        name: 'Low',
        image: 'MEDIA-e8548442038b4820803cf45b43e4f8e2',
      },
      // poor: {
      //   name: 'Challenging',
      //   image: 'MEDIA-5da8ad4510674485b0fdc56d608aa34c',
      // },
      moderate: {
        name: 'Medium',
        image: 'MEDIA-f92409be976b450fbadfc6f55c12f887',
      },
      // good: {
      //   name: 'Manageable',
      //   image: 'MEDIA-ea6f42f33a214db09aa40bfab53ddfd8',
      // },
      very_good: {
        name: 'High',
        image: 'MEDIA-6f9409c262cf4be69b7f2cb3f46c2d12',
      },
    },
  },
  energy_level: {
    name: 'Energy Level',
    dataBasedOnStates: {
      very_poor: {
        name: 'Fully drained',
        image: 'MEDIA-d524248f36704f4e8e9aafd1d0903caa',
      },
      poor: {
        name: '25%',
        image: 'MEDIA-7c59f5d4dc6e480a9c1ea8a4297a2242',
      },
      moderate: {
        name: '50%',
        image: 'MEDIA-c85e9af6fe0e4017b94f53053124c798',
      },
      good: {
        name: '75%',
        image: 'MEDIA-3f619478b832422d88dfadbe517dbf6f',
      },
      very_good: {
        name: 'Fully charged',
        image: 'MEDIA-944b0c129da145eca6075c59cdabdc69',
      },
    },
  },
}

export const fallbackBPMentalStateGraphServerData = [
  {
    id: 'mood',
    name: 'Mood Index',
    image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
    timeDurations: [
      {
        id: 'today',
        name: 'Today',
        averageScore: 3.7,
        averageGlobalScore: 3.1,
        maxScore: 5,
        delta: 1,
        data: [
          {
            id: 'sad',
            name: 'Sad',
            percent: 50,
            image: 'MEDIA-5d0d7aee3e7a4c4fb7d696747de44ddd',
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: 'Moderate',
            image: 'MEDIA-5cbe22172fcd4db3a7cffe3d2b7c7d92',
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: 'Less Moderate',
            image: 'MEDIA-00b8925bd3994d51b8b3a34601990fec',
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
            name: 'From moderate to normal, it is alright',
            percent: 12,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: 'Something Good',
            image: 'MEDIA-524e3720df17456ea39bc73887dca152',
            percent: 8,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'week',
        name: 'This Week',
        averageScore: 3.8,
        averageGlobalScore: 4.2,
        maxScore: 5,
        delta: 0.7,
        data: [
          {
            id: 'sad',
            name: 'Sad',
            image: 'MEDIA-5d0d7aee3e7a4c4fb7d696747de44ddd',
            percent: 23,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: 'Moderate',
            image: 'MEDIA-5cbe22172fcd4db3a7cffe3d2b7c7d92',
            percent: 15,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: 'Less Moderate',

            image: 'MEDIA-00b8925bd3994d51b8b3a34601990fec',
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
            name: 'From moderate to normal, it is alright',
            percent: 12,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: 'Something Good',
            image: 'MEDIA-524e3720df17456ea39bc73887dca152',
            percent: 20,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'month',
        name: 'This Month',
        averageScore: 2.4,
        averageGlobalScore: 2.6,
        maxScore: 5,
        delta: 0.3,
        data: [
          {
            id: 'sad',
            name: 'Sad',
            image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: 'Moderate',
            image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
            percent: 25,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: 'Less Moderate',
            image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
            percent: 18,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
            name: 'From moderate to normal, it is alright',
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: 'Something Good',
            image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
            percent: 17,
            globalPercent: 20,
          },
        ],
      },
    ],
    color: '#cda249',
  },
  {
    id: 'stress_level',
    name: 'Stress Level',
    image: mentalStateTypeInfo.stress_level.dataBasedOnStates.good.image,
    timeDurations: [
      {
        id: 'today',
        name: 'Today',
        averageScore: 4.1,
        averageGlobalScore: 3.1,
        delta: -0.5,
        maxScore: 5,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_poor.image,
            percent: 50,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.poor.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.moderate.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.good.image,
            percent: 12,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_good.image,
            percent: 8,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'week',
        name: 'This Week',
        averageScore: 3.8,
        averageGlobalScore: 4.2,
        maxScore: 5,
        delta: -0.6,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_poor.image,
            percent: 23,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.poor.image,
            percent: 15,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.moderate.image,
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.good.image,
            percent: 12,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_good.image,
            percent: 20,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'month',
        name: 'This Month',
        averageScore: 2.4,
        averageGlobalScore: 2.6,
        maxScore: 5,
        delta: -0.2,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_poor.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.poor.image,
            percent: 25,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.moderate.image,
            percent: 18,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.good.image,
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.stress_level.dataBasedOnStates.very_good.image,
            percent: 17,
            globalPercent: 20,
          },
        ],
      },
    ],
    color: '#e7a589',
  },
  {
    id: 'social_interaction',
    name: 'Social Interaction',
    image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.good.image,
    timeDurations: [
      {
        id: 'today',
        name: 'Today',
        averageScore: 3.7,
        averageGlobalScore: 3.1,
        maxScore: 5,
        delta: 2,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_poor.image,
            percent: 50,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.moderate.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.moderate.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.good.image,
            percent: 12,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_good.image,
            percent: 8,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'week',
        name: 'This Week',
        averageScore: 3.8,
        averageGlobalScore: 4.2,
        maxScore: 5,
        delta: 1,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_poor.image,
            percent: 23,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.moderate.image,
            percent: 15,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.moderate.image,
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.good.image,
            percent: 12,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_good.image,
            percent: 20,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'month',
        name: 'This Month',
        averageScore: 2.4,
        averageGlobalScore: 2.6,
        maxScore: 5,
        delta: 0.5,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_poor.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.moderate.image,
            percent: 25,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.moderate.image,
            percent: 18,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.good.image,
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.social_interaction.dataBasedOnStates.very_good.image,
            percent: 17,
            globalPercent: 20,
          },
        ],
      },
    ],
    color: '#af9ac8',
  },
  {
    id: 'job_satisfaction',
    name: 'Job Satisfaction',
    image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_poor.image,
    timeDurations: [
      {
        id: 'today',
        name: 'Today',
        averageScore: 1.8,
        averageGlobalScore: 3.1,
        maxScore: 5,
        delta: -2,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_poor.image,
            percent: 50,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.poor.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.moderate.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.good.image,
            percent: 12,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_good.image,
            percent: 8,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'week',
        name: 'This Week',
        averageScore: 2.7,
        averageGlobalScore: 4.2,
        maxScore: 5,
        delta: -0.2,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_poor.image,
            percent: 23,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.poor.image,
            percent: 15,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.moderate.image,
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.good.image,
            percent: 12,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_good.image,
            percent: 20,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'month',
        name: 'This Month',
        averageScore: 2.4,
        averageGlobalScore: 2.6,
        maxScore: 5,
        delta: -0.1,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_poor.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.poor.image,
            percent: 25,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.moderate.image,
            percent: 18,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.good.image,
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.job_satisfaction.dataBasedOnStates.very_good.image,
            percent: 17,
            globalPercent: 20,
          },
        ],
      },
    ],
    color: '#7e91b4',
  },
  {
    id: 'workload_management',
    name: 'Workload Management',
    image: mentalStateTypeInfo.workload_management.dataBasedOnStates.good.image,
    timeDurations: [
      {
        id: 'today',
        name: 'Today',
        averageScore: 3,
        averageGlobalScore: 3.1,
        maxScore: 5,
        delta: 0.7,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_poor.image,
            percent: 50,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.poor.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.moderate.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.good.image,
            percent: 12,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_good.image,
            percent: 20,
            percent: 8,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'week',
        name: 'This Week',
        averageScore: 3.8,
        averageGlobalScore: 4.2,
        maxScore: 5,
        delta: 0.3,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_poor.image,
            percent: 23,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.poor.image,
            percent: 15,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.moderate.image,
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.good.image,
            percent: 12,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_good.image,
            percent: 20,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'month',
        name: 'This Month',
        averageScore: 2.4,
        averageGlobalScore: 2.6,
        maxScore: 5,
        delta: 0.1,
        data: [
          {
            id: 'sad',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_poor.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'moderate',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.poor.image,
            percent: 25,
            globalPercent: 20,
          },
          {
            id: 'less_moderate',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.moderate.image,
            percent: 18,
            globalPercent: 20,
          },
          {
            id: 'name_if_it_is_too_long_in_this_way',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.good.image,
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'something_good',
            name: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.workload_management.dataBasedOnStates.very_good.image,
            percent: 17,
            globalPercent: 20,
          },
        ],
      },
    ],
    color: '#4e9381',
  },
  {
    id: 'mindfulness_index',
    name: 'Mindfulness Index',
    image: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_good.image,
    timeDurations: [
      {
        id: 'today',
        name: 'Today',
        averageScore: 4.1,
        averageGlobalScore: 3.0,
        maxScore: 5,
        delta: 1,
        data: [
          {
            id: 'very_less',
            name: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_poor.image,
            percent: 26,
            globalPercent: 20,
          },
          // {
          //   id: 'less',
          //   name: 'Less',
          //   image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
          //   percent: 14,
          //   globalPercent: 20,
          // },
          {
            id: 'medium',
            name: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.moderate.image,
            percent: 30,
            globalPercent: 20,
          },
          // {
          //   id: 'high',
          //   name: 'High',
          //   image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
          //   percent: 20,
          //   globalPercent: 20,
          // },
          {
            id: 'very_high',
            name: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_good.image,
            percent: 10,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'week',
        name: 'This Week',
        averageScore: 3.6,
        averageGlobalScore: 1.9,
        maxScore: 5,
        delta: 0.5,
        data: [
          {
            id: 'very_less',
            name: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.moderate.image,
            percent: 23,
            globalPercent: 20,
          },
          // {
          //   id: 'less',
          //   name: 'Less',
          //   image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
          //   percent: 15,
          //   globalPercent: 20,
          // },
          {
            id: 'medium',
            name: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_good.image,
            percent: 30,
            globalPercent: 20,
          },
          // {
          //   id: 'high',
          //   name: 'High',
          //   image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
          //   percent: 12,
          //   globalPercent: 20,
          // },
          {
            id: 'very_high',
            name: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_poor.image,
            percent: 20,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'month',
        name: 'This Month',
        averageScore: 2.5,
        averageGlobalScore: 3.9,
        maxScore: 5,
        delta: 0.1,
        data: [
          {
            id: 'very_less',
            name: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_poor.image,
            percent: 10,
            globalPercent: 20,
          },
          // {
          //   id: 'less',
          //   name: 'Less',
          //   image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
          //   percent: 25,
          //   globalPercent: 20,
          // },
          {
            id: 'medium',
            name: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.moderate.image,
            percent: 18,
            globalPercent: 20,
          },
          // {
          //   id: 'high',
          //   name: 'High',
          //   image: 'MEDIA-14faec5789f44a9ba144b4c7f80e4e43',
          //   percent: 30,
          //   globalPercent: 20,
          // },
          {
            id: 'very_high',
            name: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.mindfulness_index.dataBasedOnStates.very_good.image,
            percent: 17,
            globalPercent: 20,
          },
        ],
      },
    ],
    color: '#47673e',
  },
  {
    id: 'energy_level',
    name: 'Energy Level',
    image: mentalStateTypeInfo.energy_level.dataBasedOnStates.moderate.image,
    timeDurations: [
      {
        id: 'today',
        name: 'Today',
        averageScore: 2.7,
        averageGlobalScore: 2.1,
        maxScore: 5,
        delta: 0.2,
        data: [
          {
            id: 'very_less',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_poor.image,
            percent: 69,
            globalPercent: 0,
          },
          {
            id: 'less',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.poor.image,
            percent: 6,
            globalPercent: 20,
          },
          {
            id: 'medium',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.moderate.image,
            percent: 10,
            globalPercent: 20,
          },
          {
            id: 'high',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.good.image,
            percent: 5,
            globalPercent: 20,
          },
          {
            id: 'very_high',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_good.image,
            percent: 10,
            globalPercent: 40,
          },
        ],
      },
      {
        id: 'week',
        name: 'This Week',
        averageScore: 2.9,
        averageGlobalScore: 2.6,
        maxScore: 5,
        delta: 0.1,
        data: [
          {
            id: 'very_less',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_poor.image,
            percent: 23,
            globalPercent: 20,
          },
          {
            id: 'less',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.poor.image,
            percent: 15,
            globalPercent: 20,
          },
          {
            id: 'medium',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.moderate.image,
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'high',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.good.image,
            percent: 12,
            globalPercent: 20,
          },
          {
            id: 'very_high',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_good.image,
            percent: 20,
            globalPercent: 20,
          },
        ],
      },
      {
        id: 'month',
        name: 'This Month',
        averageScore: 3.8,
        averageGlobalScore: 3.9,
        maxScore: 5,
        delta: 0,
        data: [
          {
            id: 'very_less',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_poor.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_poor.image,
            percent: 10,
            globalPercent: 10,
          },
          {
            id: 'less',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.poor.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.poor.image,
            percent: 25,
            globalPercent: 20,
          },
          {
            id: 'medium',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.moderate.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.moderate.image,
            percent: 18,
            globalPercent: 20,
          },
          {
            id: 'high',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.good.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.good.image,
            percent: 30,
            globalPercent: 20,
          },
          {
            id: 'very_high',
            name: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_good.name,
            image: mentalStateTypeInfo.energy_level.dataBasedOnStates.very_good.image,
            percent: 17,
            globalPercent: 30,
          },
        ],
      },
    ],
    color: '#602743',
  },
]
